module.exports = __webpack_public_path__ + "img/1559124250.666333ae.jpg";